import { Backdrop } from '@material-ui/core'
import React, { FC } from 'react'
import styled from 'styled-components'
import { Spinner } from 'ui'

const LoadingBackdrop = styled(Backdrop)`
  z-index: 9999;
`

const Loading: FC = () => {
  return (
    <LoadingBackdrop open>
      <Spinner />
    </LoadingBackdrop>
  )
}

export default Loading
